import React from 'react'
import { TrendingUp, TrendingDown, DollarSign, BarChart3 } from 'lucide-react'
import { getColors } from '../../../theme/colors'
import { dateUtils } from '../../../api'

const SummaryCards = ({ summary = {}, categoryBreakdown, loading }) => {
  const colors = getColors()
  const safeSummary = {
    totalIncome: 0,
    totalExpense: 0,
    balance: 0,
    incomeCount: 0,
    expenseCount: 0,
    ...(summary || {})
  }
  const cards = [
    {
      title: 'Total Income',
      value: safeSummary.totalIncome,
      count: safeSummary.incomeCount,
      icon: TrendingUp,
      color: 'text-emerald-400',
      bgColor: 'bg-emerald-500 bg-opacity-20',
      borderColor: 'border-emerald-500'
    },
    {
      title: 'Total Expense',
      value: safeSummary.totalExpense,
      count: safeSummary.expenseCount,
      icon: TrendingDown,
      color: 'text-red-400',
      bgColor: 'bg-red-500 bg-opacity-20',
      borderColor: 'border-red-500'
    },
    {
      title: 'Net Balance',
      value: safeSummary.balance,
      count: safeSummary.incomeCount + safeSummary.expenseCount,
      icon: DollarSign,
      color: safeSummary.balance >= 0 ? 'text-emerald-400' : 'text-red-400',
      bgColor:
        safeSummary.balance >= 0
          ? 'bg-emerald-500 bg-opacity-20'
          : 'bg-red-500 bg-opacity-20',
      borderColor:
        safeSummary.balance >= 0 ? 'border-emerald-500' : 'border-red-500'
    }
  ]

  if (loading) {
    return (
      <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-8'>
        {[1, 2, 3].map(i => (
          <div
            key={i}
            className={`${colors.cardBg} ${colors.cardBgOpacity} border ${colors.cardBorder} rounded-xl p-6 animate-pulse`}
          >
            <div className='flex items-center justify-between mb-4'>
              <div className='w-6 h-6 bg-gray-600 rounded'></div>
              <div className='w-20 h-4 bg-gray-600 rounded'></div>
            </div>
            <div className='w-24 h-8 bg-gray-600 rounded mb-2'></div>
            <div className='w-16 h-4 bg-gray-600 rounded'></div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-6 mb-8'>
      {cards.map((card, index) => {
        const Icon = card.icon
        return (
          <div
            key={index}
            className={`${colors.cardBg} ${colors.cardBgOpacity} border ${colors.cardBorder} hover:${colors.cardBorderHover} rounded-xl p-6 transition-all duration-300 hover:shadow-lg`}
          >
            <div className='flex items-center justify-between mb-4'>
              <div
                className={`p-3 rounded-lg ${card.bgColor} border ${card.borderColor}`}
              >
                <Icon className={card.color} size={24} />
              </div>
              <span className={`${colors.textMuted} text-sm`}>
                {card.count} entries
              </span>
            </div>

            <div className={`text-2xl font-bold ${card.color} mb-1`}>
              {dateUtils.formatCurrency(card.value)}
            </div>

            <h3 className={`${colors.textSecondary} text-sm font-medium`}>
              {card.title}
            </h3>
          </div>
        )
      })}

    </div>
  )
}

export default SummaryCards
